"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const base_1 = __importDefault(require("./base"));
const component_1 = __importDefault(require("./component"));
const defaults_1 = require("./defaults");
class Answer extends base_1.default {
    constructor(data = {
        id: undefined,
        value: undefined,
        segment_id: undefined,
        component: undefined,
        modified: undefined,
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.value = (0, defaults_1.defaultString)(data.value);
        this.segment_id = (0, defaults_1.defaultString)(data.segment_id);
        this.component = new component_1.default((0, defaults_1.defaultObject)(data.component));
        this.modified = data.modified;
    }
    get segmentID() {
        return this.segment_id;
    }
    get convertedValue() {
        try {
            return JSON.parse(this.value);
        }
        catch {
            return this.value;
        }
    }
    static convertValue(data, index) {
        let value = (0, lodash_1.get)(data, index);
        if ((0, lodash_1.isArray)(value) && (0, lodash_1.isObjectLike)(value[0]) && !(0, lodash_1.has)(value[0], 'type')) {
            value = value === null || value === void 0 ? void 0 : value.filter((item) => !!item.value);
        }
        return (0, lodash_1.isString)(value) ? value : JSON.stringify(value);
    }
}
exports.default = Answer;
